import { useState, useMemo, useCallback } from "react";
import Select from "react-select";
import { t } from "i18next";
import PrimaryButton from "components/Form/Buttons/PrimaryButton";
import BasicTextInput from "components/Form/Inputs/common/BasicTextInput";
import RadioButton from "components/Form/RadioButton";
import { useRuleDataContext } from "../../context/RuleDataProvider";
import useDynamicFieldConfig from "../../hooks/useDynamicFieldConfig";

const RuleMessageDynamicEmail = ({
  isDynamicEmailType,
  onMessageAttributeChange,
  messageEmail,
  configList,
  placeholder,
  viewOnly,
  dynamicEmailMessage,
}) => {
  const { groupData } = useRuleDataContext();
  const [fieldSelection, setFieldSelection] = useState("");

  const groupFilter = useCallback((group) => group.isEmail, []);

  const { filteredGroupFields, selectedGroup, setSelectedGroup } =
    useDynamicFieldConfig(groupData, configList, groupFilter);

  const finalColumnList = useMemo(
    () =>
      filteredGroupFields.find((e) => "" + e.value === "" + selectedGroup)
        ?.subFields ?? [][selectedGroup],
    [filteredGroupFields, selectedGroup]
  );

  const addDynamicQueryMessage = () => {
    const foundedData = groupData.find(
      (e) => "" + e.customFieldsId === "" + fieldSelection
    );
    if (foundedData) {
      let message = dynamicEmailMessage ? `${dynamicEmailMessage}, ` : "";
      message = message + foundedData.queryString;
      onMessageAttributeChange("dynamicEmailMessage", message);
    }
  };

  return (
    <div>
      <div className="mb-3">
        <label className="form-label">
          {t("createRuleEngine.settingsTab.messageOptions.emailType")}
        </label>
        <div>
          <RadioButton
            id={"staticEmailMessage"}
            label={t("createRuleEngine.settingsTab.messageOptions.static")}
            isChecked={!isDynamicEmailType}
            onChange={(e) => {
              onMessageAttributeChange("isDynamicEmailType", !e.target.checked);
            }}
          />
          <RadioButton
            id={"dynamicEmailMessage"}
            label={t("createRuleEngine.settingsTab.messageOptions.dynamic")}
            isChecked={isDynamicEmailType}
            onChange={(e) => {
              onMessageAttributeChange("isDynamicEmailType", e.target.checked);
            }}
          />
        </div>
      </div>

      {isDynamicEmailType ? (
        <div className="mb-3">
          <span
            className="text-danger mb-3 d-block"
            style={{ fontSize: "14px", fontWeight: "bold" }}
          >
            {t("createRuleEngine.settingsTab.messageOptions.dynamicEmailNote")}
          </span>
          <div className="d-flex gap-3 mb-3">
            <div className="w-100">
              <Select
                options={filteredGroupFields}
                placeholder="Group select"
                onChange={(options) => {
                  setSelectedGroup(options.value);
                }}
                classNamePrefix={"select"}
                menuPosition={"fixed"}
                isDisabled={viewOnly}
              />
            </div>
            <div className="w-100">
              <Select
                options={finalColumnList}
                placeholder="Field select"
                onChange={(options) => {
                  setFieldSelection(options.value);
                }}
                classNamePrefix={"select"}
                menuPosition={"fixed"}
                isDisabled={viewOnly}
              />
            </div>
            <PrimaryButton
              title={"Add"}
              onClick={addDynamicQueryMessage}
              disabled={viewOnly}
            />
          </div>
          <textarea
            style={{
              minHeight: "120px",
            }}
            name={`dynamic-email-field`}
            className="form-control"
            rows={5}
            placeholder={placeholder}
            value={dynamicEmailMessage}
            disabled={true}
            onChange={(e) => {
              onMessageAttributeChange("dynamicEmailMessage", e.target.value);
            }}
          />
        </div>
      ) : (
        <BasicTextInput
          label={t(
            "createRuleEngine.settingsTab.messageOptions.emailMessage.emailLabel"
          )}
          groupProps={{
            controlId: "email-address",
            className: "mb-3",
          }}
          inputProps={{
            placeholder: t(
              "createRuleEngine.settingsTab.messageOptions.emailMessage.emailPlaceholder"
            ),
          }}
          disabled={viewOnly}
          value={messageEmail}
          onChange={(e) => {
            onMessageAttributeChange("messageEmail", e.target.value);
          }}
        />
      )}
    </div>
  );
};

export default RuleMessageDynamicEmail;
